<template>
    <div class="flex flex-col relative h-auto">
        <a class="w-full" :href="cta_url">
            <img
                :src="
                    props.media ? props.media : 'https://picsum.photos/210/210'
                "
                class="flex w-full h-full object-cover"
            />
        </a>
        <div class="md:absolute md:bottom-0 flex flex-col">
            <h4>{{ props.title }} test1</h4>
            <a :href="cta_url"> {{ props.cta_text }} test2 </a>
        </div>
    </div>
</template>
<script lang="ts" setup>
    // import {  } from 'vue'

    const props = defineProps<{
        title: { type: string; default: "" };
        cta_text: { type: string; default: "" };
        cta_url: { type: string; default: "" };
        media: { type: string; default: "" };
    }>();
</script>
